import React, { useState } from 'react';
import { siteData } from '../data';

export default function Contact() {
  const [form, setForm] = useState({ name: '', phone: '', email: '', course: '', message: '' });
  const [sent, setSent] = useState(false);

  const courses = ['IT Fundamentals (CCC/DCA/ADCA)', 'AutoCAD', 'Hardware & Networking', 'Tally & Accounting',
    'Graphic Design', 'Digital Marketing', 'Typing & Data Entry', 'Programming Languages',
    'Spoken English', 'Fashion Design', 'Beautician / Parlor', 'E-Commerce'];

const handleSubmit = (e: React.FormEvent) => {
  e.preventDefault();

  if (!form.name || !form.phone) {
    alert("Please enter your Name and Phone Number");
    return;
  }

  const phoneNumber = "917669669222"; // WhatsApp number (without +)

  const text = `Hi ITS Academy,

I am interested in your course.

👤 Name: ${form.name}
📞 Phone: ${form.phone}
📧 Email: ${form.email || "Not provided"}

📝 Message:
${form.message || "No additional message."}

Please contact me with full details.`;

  const encodedText = encodeURIComponent(text);
  const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedText}`;

  // Open WhatsApp
  window.open(whatsappURL, "_blank");

  // Keep your existing success animation
  setSent(true);

  setTimeout(() => {
    setSent(false);
    setForm({
      name: '',
      phone: '',
      email: '',
      course: '',
      message: ''
    });
  }, 4000);
};

  const inputStyle = {
    width: '100%', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '2px', padding: '14px 18px', color: 'white', fontFamily: 'DM Sans,sans-serif',
    fontSize: '0.9rem', transition: 'all 0.3s ease',
  };

  return (
    <section id="contact" className="py-24 md:py-32 relative" style={{background:'#0F1629'}}>
      <div className="grid-bg absolute inset-0 opacity-20" />
      <div className="orb w-96 h-96 top-0 right-0 opacity-10" style={{background:'rgba(200,168,75,0.4)'}} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="mb-16 reveal">
          <span className="section-tag">Get In Touch</span>
          <h2 className="font-playfair font-black text-white" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(2rem,3.5vw,3rem)'}}>
            Start Your Journey<br/>With <span style={{color:'#C8A84B'}}>ITS Academy</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16">
          {/* Left: Info */}
          <div className="reveal-left space-y-6">
            {/* Contact cards */}
            <div className="p-6 rounded-sm group hover:border-yellow-500/40 transition-all duration-300"
              style={{background:'rgba(255,255,255,0.03)',border:'1px solid rgba(200,168,75,0.12)'}}>
              <div style={{fontFamily:'Space Mono,monospace',fontSize:'0.68rem',letterSpacing:'3px',textTransform:'uppercase',color:'#C8A84B',marginBottom:'12px'}}>
                📍 Head Office
              </div>
              <p style={{color:'rgba(212,207,197,0.7)',lineHeight:'1.8',fontSize:'0.9rem'}}>
                {siteData.headOffice}
              </p>
            </div>

            <div className="p-6 rounded-sm hover:border-yellow-500/40 transition-all duration-300"
              style={{background:'rgba(255,255,255,0.03)',border:'1px solid rgba(200,168,75,0.12)'}}>
              <div style={{fontFamily:'Space Mono,monospace',fontSize:'0.68rem',letterSpacing:'3px',textTransform:'uppercase',color:'#C8A84B',marginBottom:'12px'}}>
                📞 Phone & Email
              </div>
              {siteData.phone.map(p => (
                <div key={p} className="mb-2"><a href={`tel:${p.replace(/\s/g,'')}`} style={{color:'rgba(212,207,197,0.7)',fontSize:'0.9rem',textDecoration:'none'}} className="hover:text-yellow-400 transition-colors">{p}</a></div>
              ))}
              <a href={`mailto:${siteData.email}`} style={{color:'#C8A84B',fontSize:'0.9rem',textDecoration:'none'}} className="hover:underline">{siteData.email}</a>
            </div>

            {/* Branches */}
            <div>
              <h3 className="font-playfair font-bold text-white text-xl mb-4" style={{fontFamily:'Playfair Display,serif'}}>
                All <span style={{color:'#C8A84B'}}>Branches</span>
              </h3>
              <div className="space-y-2">
                {siteData.allBranches.map((b, i) => (
                  <div key={i} className="flex gap-3 py-3 border-b transition-all duration-300 hover:pl-2"
                    style={{borderColor:'rgba(200,168,75,0.08)',paddingLeft:'0'}}>
                    <div className="w-2 h-2 rounded-full flex-shrink-0 mt-1.5" style={{background:'#C8A84B'}} />
                    <div>
                      <div className="text-white font-semibold text-sm">{b.label}</div>
                      <div style={{color:'rgba(212,207,197,0.5)',fontSize:'0.8rem',lineHeight:'1.5',marginTop:'2px'}}>{b.address}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Social links */}
            <div>
              <h3 className="font-playfair font-bold text-white text-lg mb-4" style={{fontFamily:'Playfair Display,serif'}}>
                Connect With <span style={{color:'#C8A84B'}}>Us</span>
              </h3>
              <div className="flex gap-3 flex-wrap">
                {[
                  { label: 'Google', icon: '⭐', href: siteData.social.google },
                  { label: 'Facebook', icon: '📘', href: siteData.social.facebook },
                  { label: 'Instagram', icon: '📸', href: siteData.social.instagram },
                  { label: 'YouTube', icon: '▶️', href: siteData.social.youtube },
                  { label: 'WhatsApp', icon: '💬', href: `https://wa.me/917669669222` },
                ].map(s => (
                  <a key={s.label} href={s.href} target="_blank" rel="noreferrer"
                    className="flex items-center gap-2 px-4 py-2 rounded-sm text-sm transition-all duration-300 hover:border-yellow-500/40"
                    style={{background:'rgba(255,255,255,0.03)',border:'1px solid rgba(200,168,75,0.12)',color:'rgba(212,207,197,0.7)'}}>
                    <span>{s.icon}</span>
                    <span>{s.label}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Form */}
          <div className="reveal-right">
            <div className="p-8 md:p-10 rounded-sm" style={{background:'rgba(255,255,255,0.03)',border:'1px solid rgba(200,168,75,0.12)'}}>
              <h3 className="font-playfair font-bold text-white text-2xl mb-6" style={{fontFamily:'Playfair Display,serif'}}>
                Enquiry Form
              </h3>
              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label style={{display:'block',fontSize:'0.68rem',letterSpacing:'2px',textTransform:'uppercase',color:'rgba(212,207,197,0.45)',marginBottom:'8px',fontFamily:'Space Mono,monospace'}}>Full Name *</label>
                  <input style={inputStyle} placeholder="Enter your full name" required
                    value={form.name} onChange={e => setForm({...form,name:e.target.value})} />
                </div>
                <div>
                  <label style={{display:'block',fontSize:'0.68rem',letterSpacing:'2px',textTransform:'uppercase',color:'rgba(212,207,197,0.45)',marginBottom:'8px',fontFamily:'Space Mono,monospace'}}>Phone Number *</label>
                  <input style={inputStyle} placeholder="+91 XXXXX XXXXX" required type="tel"
                    value={form.phone} onChange={e => setForm({...form,phone:e.target.value})} />
                </div>
                <div>
                  <label style={{display:'block',fontSize:'0.68rem',letterSpacing:'2px',textTransform:'uppercase',color:'rgba(212,207,197,0.45)',marginBottom:'8px',fontFamily:'Space Mono,monospace'}}>Email Address</label>
                  <input style={inputStyle} placeholder="you@email.com" type="email"
                    value={form.email} onChange={e => setForm({...form,email:e.target.value})} />
                </div>
                <div>
                  <label style={{display:'block',fontSize:'0.68rem',letterSpacing:'2px',textTransform:'uppercase',color:'rgba(212,207,197,0.45)',marginBottom:'8px',fontFamily:'Space Mono,monospace'}}>Message (Optional)</label>
                  <textarea style={{...inputStyle,minHeight:'100px',resize:'vertical'}} placeholder="Tell us about your goals..."
                    value={form.message} onChange={e => setForm({...form,message:e.target.value})} />
                </div>
                <button type="submit" className="btn-gold w-full justify-center text-sm tracking-widest uppercase font-bold"
                  style={{padding:'16px',transition:'all 0.3s ease',background: sent ? '#22c55e' : '#C8A84B'}}>
                  {sent ? '✓ Enquiry Sent! We\'ll Call You Soon' : 'Send Enquiry →'}
                </button>
              </form>
              <p style={{color:'rgba(212,207,197,0.3)',fontSize:'0.72rem',textAlign:'center',marginTop:'16px'}}>
                Or call us directly: <a href="tel:+917669669222" style={{color:'#C8A84B'}}>+91 7669669222</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
